"use client";

import React from "react";

const IndustryDefinitions: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Industry Definitions: Understanding Dental Terms
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Before we dive into why dental sealants are preferred over other
        treatments, let&#39;s quickly define some common terms you might encounter when
        discussing oral health with your dentist:
      </p>
      <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg">
        {[
          <span key="1">
            <strong>Carious lesions:</strong> These are areas of tooth decay, often
            referred to as cavities or holes in the teeth. They occur when bacteria
            produce acid that erodes the enamel, creating a weak spot.
          </span>,
          <span key="2">
            <strong>Pit and fissure sealants:</strong> This is just another term
            for dental sealants. The &quot;pit&quot; refers to the tiny grooves on the
            chewing surfaces of your back teeth, while &quot;fissure&quot; describes the
            larger crevices between those pits.
          </span>,
        ].map((item, idx) => (
          <li
            key={idx}
            className="group hover:bg-gray-50 transition-all duration-300 rounded-md py-1"
          >
            {item}
          </li>
        ))}
      </ul>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Now that we have a better understanding of these terms let&#39;s explore why
        dental sealants are often the preferred choice for preventing tooth decay.
      </p>
    </div>
  );
};

export default IndustryDefinitions;